import React from 'react';
import { TaskDescriptionEditor } from './TaskDescriptionEditor';
import { TaskSubtasks } from './TaskSubtasks';

// Contenido de "info" del panel de detalle de una tarea: el editor de descripción + la sección
// de subtareas (integración main→dev, epic D1.4 — extraído del `renderInfoContent` inline de
// `ComponentTaskHoy` para hacer sitio, bajo el ratchet, al cableado del Cuadro de Trabajo).
// Presentacional: el `subtaskForm` llega ya armado como slot desde el contenedor (mismo
// criterio que `TaskDetailPanel` con sus slots).

export const TaskInfoContent = ({
    taskId,
    initialDescriptionHtml,
    userId,
    currentUser,
    isDatePopoverOpen,
    onSaveDescription,
    parentTask,
    systemUsers,
    usersToSelectFrom,
    onOpenTask,
    subtasks,
    subtaskForm,
}) => (
    <>
        <TaskDescriptionEditor key={taskId}
            taskId={taskId}
            initialHtml={initialDescriptionHtml}
            userId={userId}
            currentUser={currentUser}
            isDatePopoverOpen={isDatePopoverOpen}
            onSaveDescription={onSaveDescription}
            parentTask={parentTask}
            systemUsers={systemUsers}
            usersToSelectFrom={usersToSelectFrom}
            onOpenTask={onOpenTask}
        />

        <TaskSubtasks
            subtasks={subtasks}
            systemUsers={systemUsers}
            onOpenTask={onOpenTask}
            subtaskForm={subtaskForm}
        />
    </>
);

export default TaskInfoContent;
